import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../_services';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const currentUser = this.authenticationService.currentUserValue;
        const currentFinger = this.authenticationService.currentUserValueFP;
        
        if (currentUser) {
            request = request.clone({
                setHeaders: {
                    Authorization: `${currentUser.token},fp=${currentFinger}`,
                    Accept: 'application/json, text/plain, */*',
                    'Accept-Language': '1',
                },
            });
        } 

        return next.handle(request);
    }
}
